<script>
    import SFS2X, { SFSObject } from "sfs2x-api";
    import { get } from 'svelte/store';
    import { addBalance, getUserData, reportUser, updateUserName } from '../controllers/APIController';
    import { unfriendUser } from '../controllers/SFSController';
    import friendsStore from '../stores/friendsStore';
    import userStore from '../stores/userStore';
    import { showToast } from '../utils/Toast';
    import { createEventDispatcher } from 'svelte';
    import StatsPanel from "./StatsPanel.svelte";

    const dispatcher = createEventDispatcher();
    
    let editorPanel;
    let nameInput;
    let isMyPanel = false;
    let isFriend = false;
    let isNameEdited = false;
    let userData;
    let statsPanel;

    export function show(data)
    {
        userData = data;
        isMyPanel = (userData.user_id == get(userStore).user_id);
        isFriend = checkIfFriends(userData.user_id);
        if (nameInput)
            nameInput.value = userData.name;
        editorPanel.style.display = "block";
    }

    function checkIfFriends(userId)
    {
        let friends = get(friendsStore).friends;
        for(let friend of friends)
            if (friend.uid == userData.user_id)
                return true;

        return false;
    }

    function onApply()
    {
        if (isMyPanel)
        {
            userData.name = nameInput.value;
            userStore.update(user => { user.name = nameInput.value; return user;});
            updateUserName(get(userStore).user_id, nameInput.value);
            isNameEdited = false;
        }
    }

    function onCancel()
    {
        if (nameInput)
            nameInput.value = userData.name;
        isNameEdited = false;
    }

    export function hide()
    {
        editorPanel.style.display = "none";
    }

    function copyUserId()
    {
        navigator.clipboard.writeText(userData.user_id);
        showToast("User Id copied to clipboard");
    }

    function onAddBalance()
    {
        addBalance(get(userStore).user_id, 1000);
        setTimeout(() => {location.reload()}, 2000);
    }

    function onSendFriendInvite()
    {
        hide();
        dispatcher('sendInvite', userData);
    }

    function onUnfriend()
    {
        hide();
        
        unfriendUser(userData.user_id);
    }

    function onReport()
    {
        reportUser(userData.user_id, "inappropriate_poker_chat", "hate_speech", "He said something awful!");
        showToast(userData.user_id + " reported for hate speech", null);
    }

    async function onStats()
    {
        hide();

        if (isMyPanel)
            statsPanel.show(get(userStore).user_id);
        else
            statsPanel.show(get(userStore).user_id, userData.user_id);
    }

</script>

<ion-card class="panel" bind:this={editorPanel} style="display: none;">
    <div style="text-align: right; width: 100%; padding: 10px;"><a style="cursor: pointer;" on:click={hide}>X</a></div>
    <ion-card-header style="text-align: center;">
        <ion-card-title>User Profile</ion-card-title>
    </ion-card-header>
  
    {#if userData}
    <ion-card-content style="text-align: center;">
        <div>
            <img class="profilePhoto" src={userData.avatar} alt="Photo">
        </div>
        {#if isMyPanel}
        <ion-item>
            <ion-input bind:this={nameInput} on:change={() => {isNameEdited = true;}} value="{userData.name}" style="text-align: center;" type="text"></ion-input>
        </ion-item>
        {#if isNameEdited}
        <div class="hbox center" style="padding-top: 15px;">
            <a style="cursor: pointer;" on:click={onApply}>[Apply]</a>
            <a style="cursor: pointer;" on:click={onCancel}>[Cancel]</a>
        </div>
        {/if}
        <div class="hbox center" style="padding-top: 15px;">
            <ion-button on:click={onAddBalance}>Add 1000 to balance</ion-button>
        </div>
        <br/>
        {:else}
        <ion-item>
            <ion-input bind:this={nameInput} readonly=true value="{userData.name}" style="text-align: center;" type="text"></ion-input>
        </ion-item>
        <div class="hbox center" style="padding-top: 15px;">
            {#if isFriend}
                <ion-button on:click={onUnfriend}>Unfriend</ion-button>
            {:else}
                <ion-button on:click={onSendFriendInvite}>Send Friend Invite</ion-button>
            {/if}
        </div>
        <br/>
        {/if}
        
        <span class="center" on:click={onStats}><a style="cursor: pointer;">[stats]</a></span>
        
        <span class="center" on:click={copyUserId}>{userData.user_id} &nbsp;<a style="cursor: pointer;">[copy]</a></span>
        <br/>

        {#if !isMyPanel}
        <span class="center" on:click={onReport}><a style="cursor: pointer;">[report]</a></span>
        {/if}
        
    </ion-card-content>
    {/if}
</ion-card>

<StatsPanel bind:this={statsPanel} />

<style>
    .panel {
        position: absolute;
        width: 280px;
        height: 420px;
        left: 260px;
        top: 100px;
    }

    .profilePhoto {
        width: 100px;
        height: 100px;
    }
</style>